"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const ProfileMenuView_1 = __importDefault(require("./ProfileMenuView"));
const hooks_1 = require("../../hooks");
/**
 * Fetches and displays the currently logged-in user.
 *
 * Optionally displays a "Logout" link and a custom list of `MenuItems` in a dropdown after clicking the User's name.
 */
const ProfileMenu = ({ menuItems = [], enableLogout = false, name = '', loading = true, }) => {
    const delayComplete = hooks_1.useDelay(300); // delay the rendering of the loading indicator by 300ms
    const showProgress = loading && delayComplete;
    return (react_1.default.createElement(react_1.default.Fragment, null, showProgress ? (react_1.default.createElement(core_1.LinearProgress, null)) : (react_1.default.createElement(ProfileMenuView_1.default, { name: name, menuItems: menuItems, enableLogout: enableLogout }))));
};
exports.default = ProfileMenu;
